import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "to", "target", "rel", "referrerpolicy", "download"],
  _excluded2 = ["as", "type", "isActive", "isDisabled", "onClick", "className", "role", "tabIndex"];
import React, { forwardRef, useCallback } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import 'focus-visible';
import { useTabIndexContext } from 'components/TabIndexContext';
var Clickable = styled.button.withConfig({
  displayName: "ButtonCore__Clickable",
  componentId: "sc-z48ctd-0"
})(["display:inline-block;margin:0;padding:0;vertical-align:middle;font:inherit;text-decoration:none;text-align:inherit;color:inherit;background-color:transparent;border:none;border-radius:0;appearance:none;&:not(.is-disabled){cursor:pointer;}&:focus:not(.focus-visible),&:focus:not([data-focus-visible-added]){outline:none;}&.focus-visible,&[data-focus-visible-added]{outline:3px solid currentColor;outline-offset:3px;}&::-moz-focus-inner{padding:0;border:0;}"]);
function filterLinkProps(props, isDisabled) {
  if (isDisabled) {
    var href = props.href,
      to = props.to,
      target = props.target,
      rel = props.rel,
      referrerpolicy = props.referrerpolicy,
      download = props.download,
      remainingProps = _objectWithoutProperties(props, _excluded);
    return remainingProps;
  }
  return props;
}
export var ButtonCore = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    type = _ref.type,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    className = _ref.className,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    otherProps = _objectWithoutProperties(_ref, _excluded2);
  var tabIndexContext = useTabIndexContext();
  var isButton = as === 'button';
  /**
   * There's no such thing as a disabled anchor tag in HTML,
   * so if one should appear "disabled", we render it as a `span`
   */
  var isDisabledLink = !isButton && !role && isDisabled || false;
  var Component = isDisabledLink && 'span' || as || 'button';
  var defaultType = !type && isButton ? 'button' : type;
  var classes = classNames(className, {
    'is-active': isActive,
    'is-disabled': isDisabled
  });
  var click = useCallback(function (event) {
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  }, [isDisabled, onClick]);
  if (Component === 'a' && !(otherProps !== null && otherProps !== void 0 && otherProps.href)) {
    // eslint-disable-next-line no-console
    console.warn('Buttoncore: The `href` prop is required for `a`. Please provide a href or use a different component');
  }
  return (
    /*#__PURE__*/
    /*
     Warning!!! `Clickable` is currently not being properly typechecked.
     Comment out `otherProps` and `as` when making changes to check types 
    */
    React.createElement(Clickable, _extends({}, filterLinkProps(otherProps, isDisabledLink), {
      as: Component,
      ref: ref,
      type: defaultType,
      role: role,
      "aria-disabled": (isButton || !!role) && isDisabled ? 'true' : undefined,
      "aria-pressed": isButton && isActive ? 'true' : isActive === false ? 'false' : undefined,
      tabIndex: tabIndexContext !== null && tabIndexContext !== void 0 ? tabIndexContext : tabIndex,
      onClick: click,
      className: classes
    }))
  );
});
ButtonCore.displayName = 'ButtonCore';
export default ButtonCore;